import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createMaestrosProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "maestros",
        label: "Maestros",
        subLabel: "Gestión de maestros",
        action: ctx.navigateModule("escuelas/maestros"),
        search: (): ISearchResult[] => ([])
    };
};